export const supportText = {
  ru: {
    title: 'Поддержка G-Launcher', open: 'Поддержка', close: 'Закрыть чат',
    loading: 'Подключаем поддержку…', unavailable: 'Сейчас не удалось открыть чат.',
    fallback: 'Ваш вопрос можно отправить через форму обратной связи. Мы сохраним обращение и ответим по email.',
    retry: 'Попробовать ещё раз', contacts: 'Написать через форму',
    intro: 'Нужна помощь с сервисом?', description: 'Напишите в поддержку. Подписка для обращения не требуется.',
    privacy: 'Не отправляйте пароли и данные банковских карт.', files: 'До 5 файлов, всего до 5 МБ: PDF, JPG, PNG, WebP.',
    unread: 'Новые ответы', operator: 'Кабинет поддержки', operatorHint: 'Отдельная учётная запись оператора',
    frame: 'Переписка со службой поддержки',
  },
  kk: {
    title: 'G-Launcher қолдау қызметі', open: 'Қолдау', close: 'Чатты жабу',
    loading: 'Қолдау қызметіне қосылуда…', unavailable: 'Қазір чатты ашу мүмкін болмады.',
    fallback: 'Сұрағыңызды кері байланыс нысаны арқылы жіберіңіз. Өтініш сақталып, жауап email арқылы жіберіледі.',
    retry: 'Қайта көру', contacts: 'Нысан арқылы жазу',
    intro: 'Сервис бойынша көмек керек пе?', description: 'Қолдау қызметіне жазыңыз. Өтініш беру үшін жазылым қажет емес.',
    privacy: 'Құпиясөздер мен банк карталарының деректерін жібермеңіз.', files: '5 файлға дейін, жалпы 5 МБ: PDF, JPG, PNG, WebP.',
    unread: 'Жаңа жауаптар', operator: 'Қолдау кабинеті', operatorHint: 'Оператордың жеке тіркелгісі',
    frame: 'Қолдау қызметімен хат алмасу',
  },
};
